import {
  OrganizationContext,
  OrganizationContextProps,
} from '@web-app/hocs/organization';
import {
  getOrganizationConfig,
  OrganizationConfig,
} from '@web-app/utils/api/whitelabel/organization-configs';
import { useContext, useMemo } from 'react';

/**
 * Hook to get the current organization's configuration
 *
 * @returns The complete organization configuration object, or null if loading or no organization
 */
export const useOrganizationConfig = (): OrganizationConfig | null => {
  const { organizationId, isLoadingOrganization } =
    useContext<OrganizationContextProps>(OrganizationContext);

  return useMemo(() => {
    // Return null while loading or if no organizationId to avoid falling back to Berry Street default
    if (isLoadingOrganization || !organizationId) {
      return null;
    }
    return getOrganizationConfig(organizationId);
  }, [organizationId, isLoadingOrganization]);
};
